const initialState = {
  selectedLanguage: {
    language: 'en',
    lang: 'en',
    messages: 'en'
  }
};

export default initialState;
